import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const VILLAGE_MAP_URL = "https://customer-assets.emergentagent.com/job_988ca3c4-0353-4296-b3e4-3dfc4a85f5c2/artifacts/3zxe07fe_The%20Alchemy%20Village%206%20Paths%20to%20YOU..png";

const hotspots = [
  { id: 'fuck-thatt', route: '/path/fuck-thatt', top: '20%', left: '3%', width: '26%', height: '25%', label: 'F.U.C.K. T.H.A.T.T.' },
  { id: 'fear', route: '/path/fear', top: '20%', left: '70%', width: '27%', height: '25%', label: 'F.E.A.R. Path' },
  { id: 'life-shopping', route: '/path/life-shopping', top: '40%', left: '2%', width: '26%', height: '23%', label: 'Life-Shopping' },
  { id: 'me-treat', route: '/path/me-treat', top: '38%', left: '66%', width: '28%', height: '23%', label: 'ME-Treat' },
  { id: 'gangstachef', route: '/path/gangstachef', top: '62%', left: '5%', width: '30%', height: '24%', label: "GangstaChef's Kitchen" },
  { id: 'fire-circle', route: '/path/fire-circle', top: '62%', left: '60%', width: '32%', height: '24%', label: 'Fire Circle' },
];

export default function LifeMapPage() {
  const navigate = useNavigate();
  const { user, token } = useAuth();
  const API = process.env.REACT_APP_BACKEND_URL;

  const trackPath = async (pathId) => {
    if (token) {
      try {
        await fetch(`${API}/api/profile/track-path`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ path_id: pathId }),
        });
      } catch { /* silent */ }
    }
  };

  const handlePathClick = (spot) => {
    trackPath(spot.id);
    navigate(spot.route);
  };

  return (
    <section data-testid="lifemap-page" className="lifemap-page">
      <div className="lifemap-header">
        <h1 data-testid="lifemap-title" className="lifemap-title">
          The Village Life-Map
        </h1>
        <p className="lifemap-subtitle">Click on any path to begin your journey</p>
        {user && (
          <div className="lifemap-user-bar">
            <span className="lifemap-user-greeting">Welcome, {user.name}</span>
            <button className="village-btn village-btn--secondary village-btn--sm" onClick={() => navigate('/mirror')} data-testid="lifemap-mirror-btn">
              The Mirror
            </button>
            <button className="village-btn village-btn--secondary village-btn--sm" onClick={() => navigate('/profile')}>
              My Profile
            </button>
          </div>
        )}
        {!user && (
          <div className="lifemap-user-bar">
            <button className="village-btn village-btn--secondary village-btn--sm" onClick={() => navigate('/login')}>
              Sign In
            </button>
          </div>
        )}
      </div>

      <div className="village-map-wrapper" data-testid="village-map">
        <img src={VILLAGE_MAP_URL} alt="The Alchemy Village - 6 Paths to YOU" className="village-map-image" />

        {/* Fireflies */}
        <div className="vfx-firefly vfx-ff-1" />
        <div className="vfx-firefly vfx-ff-2" />
        <div className="vfx-firefly vfx-ff-3" />
        <div className="vfx-firefly vfx-ff-4" />
        <div className="vfx-firefly vfx-ff-5" />
        <div className="vfx-firefly vfx-ff-6" />
        <div className="vfx-firefly vfx-ff-7" />
        <div className="vfx-firefly vfx-ff-8" />

        {hotspots.map((spot) => (
          <button
            key={spot.id}
            data-testid={`path-card-${spot.id}`}
            className={`map-hotspot ${user?.paths_visited?.includes(spot.id) ? 'map-hotspot--visited' : ''}`}
            style={{ top: spot.top, left: spot.left, width: spot.width, height: spot.height }}
            onClick={() => handlePathClick(spot)}
            aria-label={`Enter ${spot.label}`}
          >
            <span className="hotspot-tooltip">{spot.label}</span>
          </button>
        ))}
      </div>

      <div className="lifemap-footer">
        <button
          data-testid="deepdive-btn"
          className="village-btn village-btn--primary lifemap-deepdive-btn"
          onClick={() => navigate('/deepdive')}
        >
          Watch The DeepDive into F.U.C.K. T.H.A.T.T.
        </button>

        {/* Testimonial */}
        <div className="testimonial-section" data-testid="testimonial-section">
          <h2 className="testimonial-heading">What People Are Saying</h2>
          <div className="testimonial-video">
            <iframe
              src="https://www.youtube.com/embed/_DrHX664YTM"
              title="Dr. Jacqueline Testimonial"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <p className="testimonial-name">Dr. Jacqueline</p>
        </div>

        <p className="lifemap-community">
          Those who walk these paths become <strong>Village Manifestors</strong>
        </p>
      </div>
    </section>
  );
}
